// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8nGGT","TeamMemberCard":"styles_TeamMemberCard__205r6","navigation":"styles_navigation__msXUO"};